import AddFromHistoryDialog from "./AddFromHistoryDialog";
import RequestHistoryImportContent from "./RequestHistoryImportContent";

import type { SmartTableRequestImportPayload } from "@/queries/smart-tables";

interface AddFromRequestHistoryButtonProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onImport: (payload: SmartTableRequestImportPayload) => Promise<boolean>;
  isImporting: boolean;
  importProgress: number | null;
  selectionLimit?: 1;
  actionLabel?: string;
  title?: string;
  tableId?: string;
  sheetId?: string;
  targetColumnId?: string | null;
}

const AddFromRequestHistoryButton = ({
  open,
  onOpenChange,
  onImport,
  isImporting,
  importProgress,
  selectionLimit,
  actionLabel,
  title = "Add from Request History",
  tableId,
  sheetId,
  targetColumnId,
}: AddFromRequestHistoryButtonProps) => (
  <AddFromHistoryDialog<SmartTableRequestImportPayload>
    open={open}
    onOpenChange={onOpenChange}
    title={title}
    isImporting={isImporting}
    importProgress={importProgress}
    onImport={onImport}
    selectionLimit={selectionLimit}
    actionLabel={actionLabel}
    tableId={tableId}
    sheetId={sheetId}
    targetColumnId={targetColumnId}
    Content={RequestHistoryImportContent}
  />
);

export default AddFromRequestHistoryButton;
